import { render } from "./SectionTitle.vue?vue&type=template&id=192da146&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"

import "./SectionTitle.vue?vue&type=style&index=0&id=192da146&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192da146"]])

export default __exports__